import { t } from '../../../strings/i18n';
import { max, min, required } from '../../../xform';
export const ACCOUNT_NUMBER_INPUT_NAME = 'accountNumber';
const MIN_ACCOUNT_NUMBER_LENGTH = 4;
const MAX_ACCOUNT_NUMBER_LENGTH = 17;
const accountNumberConfig = () => [
    ACCOUNT_NUMBER_INPUT_NAME,
    undefined,
    'ENABLED',
    [
        required(t('errors.accountNumberRequired')),
        min(t('errors.accountNumberLengthInvalid', {
            minLength: MIN_ACCOUNT_NUMBER_LENGTH,
            maxLength: MAX_ACCOUNT_NUMBER_LENGTH
        }), MIN_ACCOUNT_NUMBER_LENGTH),
        max(t('errors.accountNumberLengthInvalid', {
            minLength: MIN_ACCOUNT_NUMBER_LENGTH,
            maxLength: MAX_ACCOUNT_NUMBER_LENGTH
        }), MAX_ACCOUNT_NUMBER_LENGTH)
    ]
];
export default accountNumberConfig;
